import { type FC, useMemo } from 'react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import type { DialogProps } from '@/dialogs/types'

export interface Props extends DialogProps {
  paymentUrls: string[]
  closable: boolean
  isOwner?: boolean
}

export const PaymentFailedDialog: FC<Props> = ({
  isOpen,
  onClose,
  closable,
  paymentUrls,
  isOwner,
}) => {
  const hasMultipleInvoices = paymentUrls.length > 1

  const paymentButtons = useMemo(
    () =>
      paymentUrls.map((url, index) => {
        const buttonText = hasMultipleInvoices
          ? `Pay invoice ${index + 1}`
          : 'Pay invoice'

        return (
          <a
            key={url}
            href={url}
            target="_blank"
            rel="noreferrer"
          >
            <Button
              className="mt-3 w-full"
              variant="destructive"
            >
              {buttonText}
            </Button>
          </a>
        )
      }),
    [hasMultipleInvoices, paymentUrls],
  )

  const description = useMemo(() => {
    if (isOwner) {
      return (
        <div className="my-5 text-center text-title ">
          Unfortunately your CreatorHero payment has failed. Please use the
          following {hasMultipleInvoices ? 'buttons' : 'button'} to pay the{' '}
          {hasMultipleInvoices ? 'invoices' : 'invoice'}. If you think, this is
          a mistake, contact our support live chat in the bottom right hand
          corner.
        </div>
      )
    }

    return (
      <div className="my-5 text-center text-title ">
        Attention: The leader of the CreatorHero account must pay the
        outstanding invoice. Failure to do so will result in restricted access
        to the account.
      </div>
    )
  }, [hasMultipleInvoices, isOwner])

  return (
    <Dialog
      show={isOpen}
      onClose={closable ? onClose : undefined}
    >
      <Dialog.Header className="grid grid-cols-3">
        <Dialog.Title className="col col-start-1 col-end-3 text-right">
          Payment failed!
        </Dialog.Title>
      </Dialog.Header>
      <Dialog.Description>
        {description}
        {isOwner && paymentButtons}
      </Dialog.Description>
    </Dialog>
  )
}
